// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"106":"project-workbench","176":"projects","818":"auth"}[chunkId] || chunkId) + "-legacy." + {"4":"c171233f","26":"1ae40894","106":"0205e5cd","176":"d7e24f6b","381":"bbc163be","732":"f5519988","818":"d1aec255","891":"acdc3d07"}[chunkId] + ".js";
};